<template>
  <header class="header" :class="{ 'is-homepage': isHomePage }">
    <v-container>
      <div class="header-items">
        <div class="header-logo">
          <nuxt-link to="/">
            <img loading="lazy" :src="isHomePage ? fullWhiteLogo : logoWhite" alt="divissa" />
          </nuxt-link>
        </div>

        <div class="blured-lights-container">
          <div class="blured-light light-blue"></div>
          <div class="blured-light light-red"></div>
        </div>
        <div class="d-flex gap-5 align-center">
          <div class="d-md-none d-block" v-if="token">
            <BildirimlerMini />
          </div>
          <button :class="['hamburger-menu', { 'is-open': isMenuOpen }]" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <nav :class="['header-nav', { 'is-open': isMenuOpen }]">
          <ul>
            <li v-for="(route, index) in routes" :key="index" class="hover-color-primary hover-bigger"
              :class="{ active: myRoute.path === route.link }">
              <nuxt-link class="menu_navi" :to="route.link"
                :rel="route.name === 'Blog' ? 'noopener noreferrer' : null">
                {{ route.name }}
              </nuxt-link>
            </li>
          </ul>
        </nav>
        <div class="header-user-action">
          <LoggedIn v-if="token && !isTokenValid" />
          <div v-else>
            <ul>
              <li>
                <v-btn variant="text" :color="isHomePage ? 'white' : 'darkPrimary'" to="/giris-yap">Giriş Yap</v-btn>
              </li>
              <li>
                <v-btn variant="flat" :color="isHomePage ? 'white' : 'darkPrimary'" to="/uye-ol">Kayıt Ol</v-btn>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </v-container>
  </header>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { useMyUserStore } from "~/stores/user";
import { useMyCommonStore } from "~/stores/common";
import { headerRoutes } from "~/utils/routes";
import LoggedIn from "../header/loggedIn.vue";
import BildirimlerMini from "../header/bildirimlerMini.vue";
import fullWhiteLogo from '~/assets/images/full-white-logo.svg';
import logoWhite from '~/assets/images/logo-white.svg';

export default defineComponent({
  components: { LoggedIn, BildirimlerMini },
  setup() {
    // Pinia stores
    const userStore = useMyUserStore();
    const commonStore = useMyCommonStore();

    // Route
    const myRoute = useRoute();

    // Computed properties
    const token = computed(() => userStore.token);
    const isTokenValid = computed(() => userStore.isTokenValid);
    const isMenuOpen = computed(() => commonStore.getIsMenuOpened);
    const routes = headerRoutes;
    const toggleMenu = () => {
      commonStore.toggleIsMenuOpen();
    };
    const isHomePage = computed(() => myRoute.path === '/');
    onMounted(() => {
      userStore.initializeState()
    });
    return {
      token,
      isTokenValid,
      isMenuOpen,
      myRoute,
      routes,
      toggleMenu,
      isHomePage,
      fullWhiteLogo,
      logoWhite,
    };
  },
});
</script>

<style scoped lang="less">
.header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 40;
  padding: 16px 0;
  transition: background-color 0.3s ease;
  background-color: #ffffff; // Default background color

  &.is-homepage {
    background: transparent ;
    .header-nav {
      ul {
        li {
          a {
            color: var(--color-white);
          }
        }
      }
    }
    .hamburger-menu {
      span {
        background-color: white;
      }
    }
  }

  .header-nav {
    ul {
      li {
        a {
          color: var(--color-title);
          opacity: 0.9;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }

  .header-user-action {
    ul {
      li {
        .v-btn {
          color: white;
          
          &.v-btn--variant-text {
            opacity: 0.9;
            
            &:hover {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

.blured-lights-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  pointer-events: none;
  z-index: -1;

  .blured-light {
    position: absolute;
    top: -75px;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    filter: blur(130px);
    opacity: 0.2;

    @media screen and (max-width: 768px) {
      top: -50px;
      width: 200px;
      height: 200px;
      opacity: 0.4;
    }
  }

  .light-blue {
    left: 20%;
    background-color: #247de3;
  }

  .light-red {
    right: 20%;
    background-color: #ff5a5a;
  }

  @media screen and (max-width: 768px) {
    .light-blue {
      left: 10%;
    }

    .light-red {
      right: 10%;
    }
  }
}
</style>
